import React from 'react'
import * as serviceWorkerRegistration from '../../serviceWorkerRegistration'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import DialogContentText from '@mui/material/DialogContentText'
import Dialog from '@mui/material/Dialog'

class UpdateConfirmation extends React.Component {
    constructor(props) {
        super(props)

        this.waiting = null
        this.state = {
            updating: false
        }
    }

    componentDidMount() {
        serviceWorkerRegistration.register({ onUpdate: this.onUpdate })
    }

    onUpdate = (registration) => {
        this.waiting = registration && registration.waiting
        this.setState({
            updating: true
        })
    }

    handleUpdate = () => {
        this.waiting && this.waiting.postMessage({ type: "SKIP_WAITING" })
        this.setState({ updating: false })
        this.waiting = null
        window.location.reload()
    }

    handleClose = () => {
        this.waiting = null
        this.setState({ updating: false })
    }

    render() {
        const {intl} = this.props

        return (
            <Dialog
                open={this.state.updating}
                onClose={this.handleClose}
                style={{zIndex: '1500'}}
            >
                <DialogTitle>{intl.formatMessage({id: "app.confirm_update_title"})}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {intl.formatMessage({id: "app.confirm_update_text"})}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button onClick={this.handleUpdate} variant="contained" color="primary">
                        {intl.formatMessage({id: "app.confirm_update"})}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default injectIntl(UpdateConfirmation)
